import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFound() {
    return (
        <div className="container">
            <div className="error-container">
                <div className="error-code">404</div>
                <div className="error-message">Oops! Page Not Found</div>
                <p>The page you are looking for does not exist.</p>
                <Link to="/" className="btn btn-primary">Go to Dashboard</Link>
            </div>
        </div>
    )
}
